import { useCreateEvent } from "@/features/events/hooks/useCreateEvent"
import { EventType as NewEventType } from "@/features/events/types/EventType"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import PrimaryButton from "../../../../components/buttons/PrimaryButton"
import LoadingSpinner from "../../../../components/LoadingSpinner"
import { PdfCard, PdfType } from "../../../../pages/new-platform/components/PdfCard"
import TrackingWidget from "../../../../pages/new-platform/components/TrackingWidget"
import { Exam } from "../../../../utils/api-objects/Exam"
import { getAllExamsByType } from "../../../../utils/apis/emr-service"
import { saveEvent } from "../../../../utils/apis/user-service"
import { BucketFolder } from "../../../../utils/enums/BucketFolder"
import { EventType } from "../../../../utils/enums/EventType"
import { useAuthStore } from "../../../../utils/stores/useAuthStore"
import { useProductsStore } from "../../../../utils/stores/useProductsStore"
import { useUserStore } from "../../../../utils/stores/useUserStore"
import { useIsMetabolicUser } from "../../../metabolic-health/hooks/useMetabolicHealth"
import { useDnaTracker } from "../hooks/useDnaTracker"
import { DnaTestTrackingStatus } from "../types/DnaTestTrackingStatus"

const DnaTest = () => {
    const { dnaTracker, dnaOrderId, updateTracker} = useDnaTracker()
    const dnaStatus = dnaTracker
    const { sendEvent } = useCreateEvent()
    const navigate = useNavigate()
    // const { dnaTestTracker, updateDNATestTracker } = useDNATestTracker()
    const { auth } = useAuthStore()
    const { userData } = useUserStore()
    const email = userData.email
    const { productsData } = useProductsStore()
    const dnaTest = productsData.dnaTest
    const membership = productsData.membership
    const isMetabolicUser = useIsMetabolicUser()

    const dnaTestUser = dnaTest && !membership

    const [status, setStatus] = useState(dnaStatus)
    const [report, setReport] = useState<Exam>()
    const [isLoading, setIsLoading] = useState(false)
    const [showPopup, setShowPopup] = useState(false)

    const idToken = auth.idToken
    const userId = auth.userId

    const canRetrieveUrl = userId && idToken && status === DnaTestTrackingStatus.ReportGenerated

    useEffect(() => {
        setStatus(dnaStatus);
    }, [dnaStatus]);

    useEffect(() => {
        if (canRetrieveUrl) {
            setIsLoading(true)
            getAllExamsByType(
                userId,
                idToken,
                BucketFolder.DnaExams,
                (exams) => {
                    setReport(exams[0])
                    setIsLoading(false)
                },
                (error) => {
                    console.error(error)
                    setIsLoading(false)
                }
            );
        }
    }, [canRetrieveUrl]);

    useEffect(() => {
        if (!email) return
        saveEvent(
            email,
            EventType.PageView,
            (success) => { console.log() },
            (error) => { console.log(error) },
            "dna_test_page",
        )

        void sendEvent({
            event: NewEventType.PAGE_VIEW,
            sub_category: "dna_test_page",
            event_metadata: { result_received: status === DnaTestTrackingStatus.ReportGenerated}
        })
    }, [])

    useEffect(() => {
        if (status === DnaTestTrackingStatus.ReportGenerated && !membership) {
            setTimeout(() => {
                setShowPopup(true);
            }, 500)
        }
    }, [status]);

    const onKitReceivedClick = () => {
        if (!dnaOrderId) return
        updateTracker(DnaTestTrackingStatus.Delivered, dnaOrderId)
        if (!email) return
        // TODO [TM]: pensa a questo
        saveEvent(
            email,
            EventType.DnaPurchaseButtonClicked,
            (success) => { console.log() },
            (error) => { console.log(error) },
            "dna_test_page"
        )
    }

    const onPurchasedClicked = async () => {
        window.open("https://www.holifya.com/products/dna-complete", "_blank")
        if (!email) return
        saveEvent(
            email,
            EventType.DnaPurchaseButtonClicked,
            (success) => { console.log() },
            (error) => { console.log(error) },
            "dna_test_page"
        )
         await sendEvent({
            event: NewEventType.BUTTON_CLICK,
            sub_category: "action_button",
            event_metadata: {action: "upsell_dna"}
         })
    }

    // ********************************************************************************

    return (
        <div className="w-full h-full flex flex-col space-y-[20px]">
            {
                status === DnaTestTrackingStatus.Purchased &&
                <div className="flex items-center mb-[20px]">
                    <div className="font-bold text-[16px] leading-[23px]">
                        Hai già ricevuto il kit?
                    </div>
                    <div
                        className="font-bold text-[16px] leading-[23px] text-holifya-blue ml-[10px] cursor-pointer"
                        onClick={onKitReceivedClick}
                    >
                        Si, già ricevuto
                    </div>
                </div>
            }
            {(status && status !== DnaTestTrackingStatus.ReportGenerated) && <TrackingWidget status={status} />}
            {
                status === DnaTestTrackingStatus.ReportGenerated && report && !isLoading &&
                <PdfCard exam={report} pdfType={PdfType.DnaTest} />
            }
            {
                status === null &&
                <div>
                    <div className="font-normal text-[16px] leading-[26px]">
                        Acquista un 🧬 <strong>Test del DNA</strong> e gestisci la ricezione del kit, il prelievo, la registrazione, l'invio in laboratorio e ricevi i tuoi risultati in questa pagina!
                    </div>
                    <div className="font-semibold text-[12px] leading-[20px] mt-[10px] mb-[20px]">
                        Per riscattare e gestire gli acquisti con questo account assicurati di utilizzare la mail <span className="text-holifya-blue">{email}</span> al momento dell'acquisto.
                    </div>
                    <div className="w-full h-[50px]">
                        <PrimaryButton
                            text="Acquista"
                            pointer={true}
                            disabled={false}
                            fontSize={16}
                            uppercase={false}
                            onClick={onPurchasedClicked}
                        />
                    </div>
                </div>
            }
            {/* {
                dnaTestUser && status !== DnaTestTrackingStatus.ReportGenerated && !isMetabolicUser &&
                <div className="mt-[30px] md:w-[800px]">
                    <UpsellCard
                        cardType={UpsellCardType.Card}
                        source_page="dna_test_page"
                    />
                </div>
            } */}
            <div className="p-[10px]" />
            {isLoading && <div className="w-full h-full absolute"><LoadingSpinner /></div>}

            {/* {showPopup && (
                <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center z-50 py-[10px]">
                    <div className="bg-white rounded-md shadow-lg w-[90%] md:w-[800px] max-h-screen overflow-y-auto">
                        <UpsellCard cardType={UpsellCardType.Popup} onCloseClick={() => setShowPopup(false)} />
                    </div>
                </div>
            )} */}
        </div>
    )
}

export default DnaTest
